/**
 * FIFO Queue
 */
export class Queue<T> {
  /**
   * Queue storage
   */
  private storage: T[] = [];

  /**
   * Constructor
   * @param capacity Maximum capacity of the queue
   */
  constructor(private capacity: number = Infinity) { }

  /**
   * Enqueues an item
   * @param item The item to be enqueued
   */
  enqueue(item: T): void {
    if (this.size === this.capacity) {
      throw Error("Queue has reached max capacity, you cannot add more items");
    }

    this.storage.push(item);
  }

  /**
   * Dequeues the first item from the queue
   * @returns
   */
  dequeue(): T | undefined {
    return this.storage.shift();
  }

  /**
   * Dequeues a specific item from the queue
   * @param item The item to be dequeued
   * @returns
   */
  dequeueItem(item: T): T | undefined {
    const idx = this.storage.indexOf(item);
    if (idx !== -1) {
      this.storage.splice(idx, 1);
      return item;
    } else {
      return undefined;
    }
  }

  /**
   * Checks if the queue contains an item
   * @param fn Filter function
   * @returns
   */
  contains(fn: (p: T) => boolean): boolean {
    return this.storage.filter(item => fn(item)).length !== 0;
  }

  /**
   * Clears the queue
   */
  clear(): void {
    this.storage.splice(0, this.storage.length);
  }

  /**
   * Gets the queue's size
   */
  get size(): number {
    return this.storage.length;
  }
}
